module.exports = __webpack_public_path__ + "img/res4-m.812ae466.png";